export const getCashRequestsForPayment = (state) =>
  state.cashRequestsForPayment.results;


